import { breakpoints, Card, Inline, Skeleton, Stack, vars } from '@etg/wings';
import { css } from '@eti/styles';

const skeletonLabel = css`
  height: 1.125rem;
  width: 50%;
`;

const SortingSkeleton = () => {
  const sortingOptionStyles = css`
    flex: 1;
    padding-inline-end: 1rem;

    &:not(:first-child) {
      padding-inline-start: 1rem;
    }

    &:not(:last-child) {
      border-right: 0.0625rem solid ${vars.colors.divider};
    }
  `;

  const sortingBarStyles = css`
    display: none;

    @media (min-width: ${breakpoints._970}) {
      display: block;
      margin-bottom: 16px;
    }
  `;

  return (
    <Card className={sortingBarStyles}>
      <Inline spacing={0}>
        {[...Array(4)].map((_, index) => (
          <Stack className={sortingOptionStyles} key={index} spacing={8}>
            <Skeleton className={skeletonLabel} />
            <Skeleton />
          </Stack>
        ))}
      </Inline>
    </Card>
  );
};

export default SortingSkeleton;
